import {
    useContext,
    useMemo,
    type FC,
    useId
} from "react";
import {
    View
} from "react-native";
import type IAccordionItemProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    AccordionPartContentProps,
    AccordionItemContextType
} from "../../type";
import {
    AccordionLayoutContext,
    AccordionItemContext,
    withAccordionContext
} from "../../context";

const AccordionItemContent: FC<AccordionPartContentProps<IAccordionItemProps>> = ({
    isDisabled: isDisabledProp = false,
    customTheme: customThemeProp,
    children,
    context,
    style,
    value,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        shapeConfigs,
        shadowAlpha,
        elevations,
        radiuses,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const baseID = useId().replace(/[^a-zA-Z0-9]/g, "");

    const layout = useContext(AccordionLayoutContext);

    const isOpen = context.openValues.includes(value);

    const isDisabled = context.isDisabled || isDisabledProp;

    const isLocked = context.expandBehaviour === "single" && !context.isCollapsible && isOpen;

    const {
        container: containerDynamicStyle
    } = useStyles({
        variant: context.variant,
        shapeConfigs,
        shadowAlpha,
        elevations,
        isDisabled,
        radiuses,
        borders,
        layout,
        colors
    });

    const itemContext = useMemo<AccordionItemContextType>(() => ({
        contentID: `accordionContent${baseID}`,
        triggerID: `accordionTrigger${baseID}`,
        isDisabled,
        isLocked,
        isOpen,
        value
    }), [
        isDisabled,
        isLocked,
        baseID,
        isOpen,
        value
    ]);

    return <AccordionItemContext.Provider
        value={itemContext}
    >
        <View
            {...props}
            style={[
                style,
                stylesheet.container,
                containerDynamicStyle
            ]}
        >
            {children}
        </View>
    </AccordionItemContext.Provider>;
};
export default withAccordionContext("item", AccordionItemContent);
